import React from "react";
import { useIntl } from "react-intl";
import { SpatialCarousel } from "@src/lms/jelly/extensions/layouts";

import { messages } from "./AudioSources.messages";
import styles from "./AudioSources.module.scss";
import { SimpleLayoutView } from "@src/lms/jelly/extensions/layouts/simple/SimpleLayoutView";
import { useBlocks } from "@jelly/lesson";
import config from "appConfig";

interface AudioSourcess {
  title: string;
}

export const AudioSources: React.FC<AudioSourcess> = () => {
  const { formatMessage } = useIntl();
  const block = useBlocks();

  return (
    <SimpleLayoutView>
      <div className={styles.AudioSources}>
        <div className={styles.rightComponent}>
          {/*// @ts-expect-error We cannot override layouts using Contexts :/ */}
          <SpatialCarousel showBreadcrumbs>
            {[
              <div key={1} className={styles.carouselItem}>
                <h3 className={styles.title}>{formatMessage(messages.G6_P3_S1_Title)}</h3>
                <p dangerouslySetInnerHTML={{ __html: formatMessage(messages.G6_P3_S1_Description) }}></p>
                <block.infoBox text={formatMessage(messages.G6_P3_S1_Note)} compact={true} />
              </div>,

              <div key={2} className={styles.carouselItem}>
                <h3 className={styles.title}>{formatMessage(messages.G6_P3_S2_Title)}</h3>
                <p dangerouslySetInnerHTML={{ __html: formatMessage(messages.G6_P3_S2_Description) }}></p>
              </div>,

              <div key={3} className={styles.carouselItem}>
                <div className={styles.imageSlide}>
                  <div className={styles.textColumn}>
                    <h3 className={styles.title}>{formatMessage(messages.G6_P3_S3_Title)}</h3>
                    <p dangerouslySetInnerHTML={{ __html: formatMessage(messages.G6_P3_S3_Description) }}></p>
                  </div>
                  <div className={styles.imageColumn}>
                    <block.image
                      src={`${config.STATIC_ASSETS_URL}/lms/guide/guide06/audio_source_types.png`}
                      onHoverAction={[
                        {
                          type: "changeOptions",
                          options: {
                            src: `${config.STATIC_ASSETS_URL}/lms/guide/guide06/audio_source_types_hover.png`,
                          },
                        },
                      ]}
                    ></block.image>
                    <p className={styles.caption}>{formatMessage(messages.G6_P3_S3_Caption)}</p>
                  </div>
                </div>
              </div>,
            ]}
          </SpatialCarousel>
        </div>
      </div>
    </SimpleLayoutView>
  );
};
